import { useCallback } from "react";

import { useObx } from "../../../../utils/UseObx";
import ApiRequestPaths from "../../../Constants/ApiRequestPaths";
import { getBmi } from "../../../Types/Entities/Patient";
import { IPatientUpdate, IQualifyStepWrapperConfig } from "../Components/QualifyStepWrapper";

interface PatientUpdateRequest extends IPatientUpdate {
  bmi?: number;
}

/** Hook for updating the persisted state of the patient. */
const useUpdatePatient: IQualifyStepWrapperConfig["UseUpdatePatient"] = ({ contactId }) => {
  const { res, err, loading, setReq } = useObx<unknown, PatientUpdateRequest>("Put Patient", {
    method: "put"
  });

  const execute = useCallback((patientUpdate: IPatientUpdate) => {
    const bmi = getBmi(patientUpdate.height, patientUpdate.weight);
    setReq(
      r =>
        r && {
          ...r,
          url: ApiRequestPaths.putPatientUrl(contactId, patientUpdate.id),
          payload: { ...patientUpdate, bmi }
        }
    );
  }, []);

  return { result: Boolean(res) || null, isLoading: loading, execute, error: Boolean(err) };
};

export default useUpdatePatient;
